import { render, staticRenderFns } from "./MovedDialog.vue?vue&type=template&id=4d851fe6&"
import script from "./MovedDialog.vue?vue&type=script&lang=js&"
export * from "./MovedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports